import { Buffer } from 'buffer';
export const currencyFormat = (value: number, minimumFractionDigits = 0) =>
  new Intl.NumberFormat('en-US', {
    minimumFractionDigits, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  }).format(value);

export const isNotInvalid = (value: any) =>
  ![NaN, undefined, null].includes(value);

export const getPreviousQuestionsValue = (
  key: string,
  questions: any[],
  questionnaireValue: any,
) => {
  const prevQuestion = questions.find(
    ({ attributeKey }) => attributeKey === key,
  );
  if (prevQuestion) {
    const qId = prevQuestion.questionId;
    return questionnaireValue[qId];
  }
  return undefined;
};

export const isValid = (value: any) =>
  (value !== null && !isNaN(value)) ?? false;

export const decodeId = id => {
  const decodedClientId = Buffer.from(id, 'base64').toString();
  return decodedClientId;
};
